import { constants } from "@/lib/CONSTANTS.js";

const state = {
  isErrorFilterApplied: true,
  checkedErrorList: constants.pageSettings.exception.filters.manifestFilterCheckbox, //UX review: by default on page load everything is checked
  selectGroup: ""
};

const mutations = {
  updateList(state, value) {
    state.checkedErrorList = value;
    state.checkedErrorList.length > 0 ? (state.isErrorFilterApplied = true) : (state.isErrorFilterApplied = false);
  },
  updateGroup(state, value) {
    state.selectGroup = value;
  }
};

const actions = {
  updateErrorList({ commit, dispatch }, value) {
    commit("updateList", value);
    if (state.checkedErrorList.length > 0) {
      dispatch("workflowSearch/invokeFilterChange", 1, { root: true });
    } else {
      dispatch("workflowSearch/invokeFilterChange", 0, { root: true });
    }
  },

  updateGroupList({ commit, dispatch }, value) {
    commit("updateGroup", value);
    commit("userAccount/setGroupId", value, { root: true });
    dispatch("workflowSearch/invokeGroupSelection", null, { root: true });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
